function t(e, r) {
  return !e || !r ? r : `${r.replace(/\s*\*$/, "").trimEnd()} *`;
}
export {
  t as formatRequiredLabel
};
